import { render, staticRenderFns } from "./StudentInfoModal.vue?vue&type=template&id=29fe5523"
import script from "./StudentInfoModal.vue?vue&type=script&lang=js"
export * from "./StudentInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29fe5523')) {
      api.createRecord('29fe5523', component.options)
    } else {
      api.reload('29fe5523', component.options)
    }
    module.hot.accept("./StudentInfoModal.vue?vue&type=template&id=29fe5523", function () {
      api.rerender('29fe5523', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/studentInfo/modules/StudentInfoModal.vue"
export default component.exports